var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-boolean-input',{attrs:{"value":_vm.item.status === 'open'},on:{"input":_vm.saveChange}})}
var staticRenderFns = []

export { render, staticRenderFns }